// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.x-GenericPortalLayout-mainLayout {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  background-color: #3C4C5E;
  color: #FEFEFE;
}
.x-GenericPortalLayout-mainLayout a:hover {
  text-decoration: underline;
  cursor: pointer;
}
.x-GenericPortalLayout-mainLayout header a,
.x-GenericPortalLayout-mainLayout footer a,
.x-GenericPortalLayout-mainLayout header a:hover,
.x-GenericPortalLayout-mainLayout footer a:hover {
  color: #FEFEFE;
}
.x-GenericPortalLayout-mainLayout header {
  padding: 15px 20px;
  display: flex;
  align-items: center;
  font-weight: lighter;
}
.x-GenericPortalLayout-mainLayout header .x-GenericPortalLayout-headerLogo {
  font-size: 18px;
  margin-left: 8px;
  margin-right: auto;
}
.x-GenericPortalLayout-mainLayout header .x-GenericPortalLayout-headerLogo > * {
  padding: 5px;
  display: inline-block;
}
.x-GenericPortalLayout-mainLayout header .x-GenericPortalLayout-headerLogo :hover {
  cursor: pointer;
}
.x-GenericPortalLayout-mainLayout footer {
  flex-shrink: 0;
  margin-top: auto;
  padding: 35px 45px;
  display: flex;
  font-weight: lighter;
}
.x-GenericPortalLayout-mainLayout footer nav > * {
  padding: 20px;
}
.x-GenericPortalLayout-mainLayout .x-GenericPortalLayout-middle {
  background-color: #f7f8f9;
  color: #28333F;
  flex-grow: 1;
  padding: 24px 24px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.19), 0 6px 6px rgba(0, 0, 0, 0.23);
}
.x-GenericPortalLayout-headerItem {
  margin: 0 15px;
}
.x-GenericPortalLayout-headerInfoBlock {
  margin: 0 15px;
  text-align: right;
}
.x-GenericPortalLayout-headerInfoBlock .x-GenericPortalLayout-top {
  font-size: 12px;
}
.x-GenericPortalLayout-headerInfoBlock .x-GenericPortalLayout-bottom {
  font-size: 16px;
}
.x-GenericPortalLayout-sparseIcon {
  padding-right: 20px;
}
.x-GenericPortalLayout-copyright {
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./modules/portal-core/components/layout/page/GenericPortalLayout.less"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EAEA,yBAAA;EACA,cAAA;AAFF;AAME;EACE,0BAAA;EACA,eAAA;AAJJ;AAQI;;;;EACE,cAAA;AAHN;AAOE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,oBAAA;AALJ;AAMI;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;AAJN;AAKM;EACE,YAAA;EACA,qBAAA;AAHR;AAHI;EASI,eAAA;AAHR;AAQE;EACE,cAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;AANJ;AAOI;EACE,aAAA;AALN;AASE;EACE,yBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;EACA,0EAAA;AAPJ;AAYA;EACE,cAAA;AAVF;AAaA;EACE,cAAA;EACA,iBAAA;AAXF;AAYE;EACE,eAAA;AAVJ;AAYE;EACE,eAAA;AAVJ;AAcA;EACE,mBAAA;AAZF;AAeA;EACE,iBAAA;AAbF","sourcesContent":["@import \"../../../styles/theme\";\n\n.mainLayout {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n\n  background-color: @color-bg-inv;\n  color: @color-text-inv;\n\n  // padding: 0 20px;\n\n  & a:hover {\n    text-decoration: underline;\n    cursor: pointer;\n  }\n\n  & header, & footer {\n    & a, & a:hover {\n      color: @color-text-inv;\n    }\n  }\n\n  & header {\n    padding: 15px 20px;\n    display: flex;\n    align-items: center;\n    font-weight: lighter;\n    & .headerLogo {\n      font-size: 18px;\n      margin-left: 8px;\n      margin-right: auto;\n      & > * {\n        padding: 5px;\n        display: inline-block;\n      }\n      :hover {\n        cursor:pointer;\n      }\n    }\n  }\n\n  & footer {\n    flex-shrink: 0;\n    margin-top: auto;\n    padding: 35px 45px;\n    display: flex;\n    font-weight: lighter;\n    & nav > * {\n      padding: 20px;\n    }\n  }\n\n  & .middle {\n    background-color: @color-body-bg;\n    color: @color-text;\n    flex-grow: 1;\n    padding: 24px 24px;\n    box-shadow: 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);\n  }\n\n}\n\n.headerItem {\n  margin: 0 15px;\n}\n\n.headerInfoBlock {\n  margin: 0 15px;\n  text-align: right;\n  & .top {\n    font-size: 12px;\n  }\n  & .bottom {\n    font-size: 16px;\n  }\n}\n\n.sparseIcon {\n  padding-right: 20px;\n}\n\n.copyright {\n  margin-left: auto;\n}\n\n.summary {\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainLayout": `x-GenericPortalLayout-mainLayout`,
	"headerLogo": `x-GenericPortalLayout-headerLogo`,
	"middle": `x-GenericPortalLayout-middle`,
	"headerItem": `x-GenericPortalLayout-headerItem`,
	"headerInfoBlock": `x-GenericPortalLayout-headerInfoBlock`,
	"top": `x-GenericPortalLayout-top`,
	"bottom": `x-GenericPortalLayout-bottom`,
	"sparseIcon": `x-GenericPortalLayout-sparseIcon`,
	"copyright": `x-GenericPortalLayout-copyright`
};
export default ___CSS_LOADER_EXPORT___;
